/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-01T03:12:01.075Z
 */

import { getEnv } from '@confluence/ssr-utilities/entry-points/env.ts';

// prettier-ignore
const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeQuery', // 42
	'PageTreeQueryWithSpaceKeyQuery', // 43
	'PermissionCheckAddCommentQuery', // 44
	'PersistentInviteEligibleQuery', // 45
	'PersonalizedTemplatesV2AllTemplatesQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 47
	'Preferences', // 48
	'PremiumTrialEotQuery', // 49
	'ReactionsContentQuery', // 50
	'RendererContentStateQuery', // 51
	'RestrictedPageWithCanViewQuery', // 52
	'ScreenQuery', // 53
	'SiteInformationQuery', // 54
	'SmartCreateFeedbackBannerQuery', // 55
	'SmartCreatePageEditorDataWrapperComponentQuery', // 56
	'SpaceNavigationQuery', // 57
	'SpaceOverviewIdQuery', // 58
	'SpaceOverviewQuery', // 59
	'SpaceQuery', // 60
	'SpaceRestrictionCheckQuery', // 61
	'ThemeQuery', // 62
	'TopNavigationQuery', // 63
	'UserSettingsQuery', // 64
	'ViewSpaceExternalCollaboratorsDialogQuery', // 65
	'WebItemLocationQuery_page.metadata.banner', // 66
	'WebItemLocationQuery_system.content.byline', // 67
	'WebItemLocationQuery_system.header_left', // 68
	'WebItemLocationQuery_system.header_left_system.user', // 69
	'WebPanelLocationQuery_atl.footer', // 70
	'WebPanelLocationQuery_atl.general', // 71
	'WebPanelLocationQuery_atl.general_atl.footer', // 72
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 73
	'WebStorageCategories', // 74
	'WelcomeMessagesQuery', // 75
	'WhiteboardUnifiedQuery', // 76
	'contentAppearanceQuery', // 77
	'contentSmartLinksORS', // 78
	'fetchMentionsProviderDataQuery', // 79
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 80
	'graphqlHelpersFetchMediaTokenQuery', // 81
	'multiMacroQueryQuery', // 82
	'multiMacroQueryWithAppKeyQuery', // 83
	'onboardingStateGetOnboardingStateQuery', // 84
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 85
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 86
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 87
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 90
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 91
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 92
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 93
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_22', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_67', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserGSPagePath_6', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_150', // 102
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 103
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 104
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_156', // 105
	'pageButtons', // 106
	'preloadAutohighlightsQuery', // 107
	'preloadContentSmartLinksQuery', // 108
	'preloadCreateSpaceQuery', // 109
	'preloadEditButtonWithSpaceKeyQuery', // 110
	'preloadEditorNodeDataProvidersDataQuery', // 111
	'preloadLegacyBridgeQuery', // 112
	'preloadOperationsQuery', // 113
	'preloadPageStatusQueryDataQuery', // 114
	'preloadPersonalSpaceDetailsQuery', // 115
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 116
	'preloadSpaceBlogCountQuery', // 117
	'preloadTemplatesCollectionEligibleQuery', // 118
	'requireSuperBatchFrontendResourceRenderQuery', // 119
	'sidenavSmartLinksORS', // 120
	'useAnalyticsByLineQuery', // 121
	'useAudioContentQuery', // 122
	'useConfluenceStandardToPremiumExperimentQuery', // 123
	'useContentClassificationContentDataClassificationQuery', // 124
	'useEditorContentModeValueQuery', // 125
	'useEmojiEverSetPropertyQuery', // 126
	'useFabricEligibilityMigrationQuery', // 127
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 128
	'useFeedTypeSelectorRefreshQuery', // 129
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 130
	'useGetCurrentStorageUsageQuery', // 131
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 132
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 133
	'useHomeWidgetStateQuery', // 134
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 135
	'useIsLoomEntryPointsEnabledQuery', // 136
	'useIsUserViewingSpaceAsAnonQuery', // 137
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 138
	'useLoomTenantProvisionStatusQuery', // 139
	'usePopularFeedWithTimeGranularityStorageQuery', // 140
	'usePreloadCommentButtonQuery', // 141
	'useReadTimeQuery', // 142
	'useRegisterAdminAnnouncementBannerQuery', // 143
	'useShareAndRestrictButtonDataQuery', // 144
	'useShortcutsSpaceNavigationQuery', // 145
	'useSpaceBaseQueryBaseQuery', // 146
	'useSpaceDetailQuery', // 147
	'useSpaceEnabledContentTypesQuery', // 148
	'useSpaceViewsDataSpaceRootQuery', // 149
	'useSpaceViewsOptionsPersistenceQuery', // 150
	'useSpacesDataMyVisitedSpacesQuery', // 151
	'useSpacesDataStarredSpacesQuery', // 152
	'useTitleContentPropertiesForEditorQuery', // 153
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 154
	'useTitleContentPropertiesForPublishedPageQuery', // 155
	'useUserByLicensedProductsQuery', // 156
];

// prettier-ignore
const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fb5efbffffb2fb9e7fffbffe73ef7f0f', /* 128 fast, 21 slow, 67 excl */
	'prod-apne2': 'b5ff7bf7fa5efbffffb2fb9ef7ff37fe7bef7f0f', /* 127 fast, 22 slow, 109 excl */
	'prod-apse': 'ddff7bf7fb5effffffb2fbbeffffbffe7befff0f', /* 135 fast, 16 slow, 66 excl */
	'prod-apse2': 'fdff7bf7fa5effffffbafbfefffffffe73efff1f', /* 138 fast, 13 slow, 66 excl */
	'prod-apsouth': 'd5fffb77fe5effffffbafbfeffff7fbe7befff1f', /* 136 fast, 12 slow, 10 excl */
	'prod-cacentral': 'fdff7b77ff7effffffbafbfeffff7ffefbefff1f', /* 141 fast, 8 slow, 6 excl */
	'prod-east': 'fdff7ff7fb7effffffbafbfefffffffefbefff1f', /* 143 fast, 9 slow, 160 excl */
	'prod-eucentral': 'bfff7ff7fb5effffffb2fb9efffffffc7bef7f0f', /* 135 fast, 18 slow, 141 excl */
	'prod-eucentral2': 'fdff7b37fa5efffeffb2f39effff7ffc3befff0f', /* 128 fast, 20 slow, 5 excl */
	'prod-euwest': 'ffff7ff7fb7effffffbafbfefffffffcfbef7f1f', /* 142 fast, 11 slow, 166 excl */
	'prod-euwest2': 'fdff7bf7fb7effffffbafbfeffff7ffefbefff1f', /* 141 fast, 9 slow, 64 excl */
	'prod-west2': '9dff7ff7fb7effffffbefbfefffffffefbefff1f', /* 142 fast, 11 slow, 142 excl */
	'stg-east': '34b3fb77a176dde237abff5d2bb94ff5d7ffeb1b', /* 106 fast, 16 slow, 85 excl */
	'stg-local': '0000000000000000000000000000000000000000', /* 0 fast, 0 slow, 72 excl */
};

const _cache = new Map<string, ReadonlySet<string>>();

function _decode(region: string): ReadonlySet<string> {
	const cached = _cache.get(region);
	if (cached) return cached;
	const hex = R[region];
	if (!hex) return _empty;
	const set = new Set<string>();
	for (let i = 0; i < Q.length; i++) {
		// eslint-disable-next-line no-bitwise
		const byteIdx = i >> 3;
		// eslint-disable-next-line no-bitwise
		const bitIdx = i & 7;
		const byte = parseInt(hex.slice(byteIdx * 2, byteIdx * 2 + 2), 16);
		// eslint-disable-next-line no-bitwise
		if (byte & (1 << bitIdx)) set.add(Q[i]);
	}
	const frozen = Object.freeze(set) as ReadonlySet<string>;
	_cache.set(region, frozen);
	return frozen;
}

const _empty: ReadonlySet<string> = Object.freeze(new Set<string>());
const _aggPrefix = 'agg_';

function _getEquivalentQueryName(queryName: string): string {
	return queryName.startsWith(_aggPrefix)
		? queryName.slice(_aggPrefix.length)
		: `${_aggPrefix}${queryName}`;
}

/**
 * Check whether a preload query is classified as fast (batchable) for the
 * current SSR region.
 *
 * @param queryName — the GraphQL operation name.
 */
export function isFastPreloadQuery(queryName: string): boolean {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	const region = process.env.REACT_SSR ? getEnv() : window.__SSR_REGION__;
	if (!region) return false;
	const fastQueries = _decode(region);
	return fastQueries.has(queryName) || fastQueries.has(_getEquivalentQueryName(queryName));
}
